// Sticky "Add to Cart" bar (mobile) — shows once the real product-form
// Add to Cart button scrolls out of view, and mirrors its price/availability
// state rather than re-implementing variant matching. Clicking the sticky
// button submits the real form, so cart-drawer.js's existing submit
// interception (Ajax add + drawer open) handles it exactly like the real
// button would. Progressive enhancement: with JS off, or on desktop, the
// bar never becomes visible (see sticky-add-to-cart.css) and the real
// in-page form still works normally.
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  const form = document.querySelector('.product-form');
  const mainSubmit = form ? form.querySelector('[data-product-submit]') : null;
  const mainPrice = document.querySelector('[data-product-price]');
  const mainCompare = document.querySelector('[data-product-compare]');

  const stickySubmit = bar.querySelector('[data-sticky-submit]');
  const stickyPrice = bar.querySelector('[data-sticky-price]');
  const stickyCompare = bar.querySelector('[data-sticky-compare]');

  // Mirror price / compare-at-price text as the main variant picker
  // (assets/decus.js) updates them on option change.
  if (mainPrice && stickyPrice) {
    stickyPrice.textContent = mainPrice.textContent;
    new MutationObserver(() => { stickyPrice.textContent = mainPrice.textContent; })
      .observe(mainPrice, { childList: true, characterData: true, subtree: true });
  }
  if (mainCompare && stickyCompare) {
    stickyCompare.textContent = mainCompare.textContent;
    stickyCompare.style.display = mainCompare.style.display;
    new MutationObserver(() => {
      stickyCompare.textContent = mainCompare.textContent;
      stickyCompare.style.display = mainCompare.style.display;
    }).observe(mainCompare, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  // Mirror disabled/label state (sold out, unavailable combo, etc.)
  if (mainSubmit && stickySubmit) {
    const syncButton = () => {
      stickySubmit.disabled = mainSubmit.disabled;
      stickySubmit.textContent = mainSubmit.disabled ? mainSubmit.textContent : 'Add to Cart';
    };
    syncButton();
    new MutationObserver(syncButton).observe(mainSubmit, {
      attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true,
    });
  }

  if (stickySubmit && form) {
    stickySubmit.addEventListener('click', () => {
      if (stickySubmit.disabled) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else if (mainSubmit) {
        mainSubmit.click();
      }
    });
  }

  // Reveal only once the real button has scrolled above the viewport
  // (i.e. the shopper has scrolled past it), hide again if it scrolls
  // back into view.
  if (mainSubmit && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      });
    }, { threshold: 0 });
    observer.observe(mainSubmit);
  }
});
